import { AppPath } from 'utils/url/appPaths';

import { AppUrlOptions, AppUrlOptionsWithParams } from '../createAppUrl.types';

/**
 * Checks whether the options has params.
 *
 * @param options The options.
 */
export function hasParams<TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath>,
): options is AppUrlOptionsWithParams<TAppPath> {
  return (options as AppUrlOptionsWithParams<TAppPath>).params !== undefined;
}
